import { render, staticRenderFns } from "./ValueDivergenceModal.vue?vue&type=template&id=07621e40"
import script from "./ValueDivergenceModal.vue?vue&type=script&lang=js"
export * from "./ValueDivergenceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports